import React from 'react';
import { render } from 'react-dom';
import { IntlProvider, addLocaleData } from 'react-intl';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import 'clorian-frontend-components/dist/clorian-frontend-components.css';
import App from './App';
import Cookie from 'js-cookie';
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";

let rootElement = document.getElementById('root');

// Define user's language.
const locale = Cookie.get('locale') || 'en';

// Split locales with a region code
const languageWithoutRegionCode = locale.toLowerCase().split(/[_-]+/)[0];

// Our translated strings
const localeData = require(`./static/locales/${languageWithoutRegionCode}.json`);

// react-intl own translations
const intlCurrentData = require(`react-intl/locale-data/${languageWithoutRegionCode}`);

/*require('moment/locale/es');
require('moment/locale/ca');*/

if (intlCurrentData) {
  addLocaleData(intlCurrentData);
} else {
  const en = require('react-intl/locale-data/en');
  addLocaleData(en);
}

// Try full locale, try locale without region code, fallback to 'en'
const messages = localeData || [];

function runApp(messages) {
  render(
    <IntlProvider locale={locale} messages={messages || []} defaultLocale="es">
      <App />
    </IntlProvider>,
    rootElement
  );
    serviceWorkerRegistration.unregister();
}

runApp(messages);
